<template>
    <Layout>
        <div class="container m_height">
            <!-- <div class="d-flex justify-content-center align-items-center mt-5">
                <div class="session_box alert alert-warning">
                    <span class="fa fa-warning fa-fw"></span>
                    Your Session will expire in <strong> 17 Minutes!</strong>
                </div>
            </div> -->

            <div class="registration_steps text-justify">
                <h1 class="cl_gr text-uppercase my-3">Registration</h1>
                <p>
                    To register, please enter the invitation code provided In your invitation letter then click the <span class="cl_gr">"ACTIVATE"</span> button.
                </p>

                <p>
                    Please note that this invitation is non transferable.
                    Attendance at The EFG Hermes & Tadawul Investor conference is reserved for clients of EFG Hermes and leading listed Saudi companies.
                </p>

                <p>
                    Space is limited and strictly reserved for those whose participation would be most directly relevant to the conference.
                    If you wish to recommend a colleague or business associate for receiving an invitation, please click <a href="mailto:VirtualConference@EFGHERMES.com">here</a>  to send their details.
                </p>

            </div>
            <form class="register_form" @submit="identifyClientSubmitted">
                <!--<h5 class="cl_gr my-4">Arrival & Depature Details</h5>-->
                <div class="alert alert-danger" v-if="errorMsg != ''">
                     {{ errorMsg }}
                </div>
                  <div class="form-group form-check">
                    <label class="form-check-label">
                      <input v-model="isAgreed" class="form-check-input" type="checkbox">I have read and accepted the above conditions of participation
                    </label>
                  </div>

                <div class="form-group required">
                    <div class="row">
                        <div :class="{ 'has-error': $v.invitation_code.$error, 'col-sm-12':true }">
                            <label for="activation_code">Activation code</label>
                            <input v-model="invitation_code" type="text" name="activation_code" class="form-control" id="activation_code">
                            <small class="text-danger" v-if="!$v.invitation_code.required">Field is required</small>
                        </div>
                    </div>
                </div>
                <div style="display: flex;" class="mt-3 mb-3">
                    <button type="submit" class="btn btn-success">Activate</button>
                    <a href="" type="submit" class="btn btn-danger ml-3">Cancel</a>
                </div>

            </form>
        </div>



    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required } from 'vuelidate/lib/validators'
import Api from '@/Api'

export default {
    name: 'Identify',
    components: {Layout},
    data() {
        return {
            invitation_code:'',
            isAgreed:false,
            errorMsg:''
        };
    },
    validations: {
        invitation_code: {required}
    },
    methods: {
        identifyClientSubmitted: function(e){
            e.preventDefault();
            if (this.$v.$invalid)
                return;
            if (!this.isAgreed)
                return alert("Sorry, You must accept terms and conditions to able to register!");
            var scope = this;
            Api().get(`auth/get-required-data-registration?invitation_code=${this.invitation_code}`)
                .then(response => {
                    let data = response.data;
                    localStorage.clear();
                    localStorage.setItem("firstTimeRegister" , "1" );
                    this.$store.dispatch("startRegistrationProccess", data)
                        .then(() => {
                            this.$router.push({name:"register"})
                        });
                })
                .catch((error) => {
                    if (error) {
                        if (error.response.status == 422) {
                            var err = error.response.data;
                            scope.errorMsg = err.errors[0].message;
                        }
                    }
                });
            //1- validation -- done
            //2- send request -- done
            //3- show error message -- done
            //4- push to register page
            //5- start timer
        }
    }
};
</script>
